var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobilePriceAtom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 107,
    viewBox: "0 0 109 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4637 71.1026L55.9898 48.4988L28.8222 37.7465",
    stroke: "#263238",
    strokeWidth: 2.3576,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1902 64.4487C43.9686 64.32 47.1358 67.2787 47.2644 71.0571C47.393 74.8354 44.4344 78.0026 40.656 78.1312C36.8777 78.2599 33.7105 75.3012 33.5818 71.5228C33.4532 67.7445 36.4119 64.5773 40.1902 64.4487Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4049 65.8979C44.3227 66.8595 45.6655 68.8162 45.7436 71.1093",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5003 29.7954C33.9948 29.6424 37.7624 33.1619 37.9154 37.6564C38.0684 42.1509 34.5489 45.9185 30.0544 46.0715C25.5598 46.2245 21.7923 42.705 21.6393 38.2105C21.4863 33.7159 25.0058 29.9484 29.5003 29.7954Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2362 31.587C34.4899 32.7206 36.0716 35.0139 36.1637 37.7173",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6141 32.8093C83.4375 32.7132 85.8043 34.9241 85.9004 37.7475C85.9965 40.571 83.7856 42.9377 80.9622 43.0339C78.1387 43.13 75.772 40.919 75.6759 38.0956C75.5797 35.2722 77.7907 32.9054 80.6141 32.8093Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1272 33.805C83.5899 34.54 84.6235 36.0305 84.6833 37.7888L82.1272 33.805Z",
    fill: "#80FFAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1272 33.805C83.5899 34.54 84.6235 36.0305 84.6833 37.7888",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2315 38.8932C59.7982 38.7037 64.4646 43.0628 64.6541 48.6296C64.8436 54.1964 60.4845 58.8628 54.9177 59.0523C49.3509 59.2418 44.6845 54.8826 44.495 49.3158C44.3055 43.7491 48.6647 39.0827 54.2315 38.8932Z",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7587 41.1999C60.5198 42.5876 62.4567 45.4042 62.5692 48.7084",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePriceAtom1);
export default __webpack_public_path__ + "static/media/mobile-price-atom-1.4da0bfcd5fbb3368a6bb8d3bbdd0d79d.svg";
export { ForwardRef as ReactComponent };